import _ from 'lodash'
import backend from '../../components/utils/backend'
import { setQueryStringVariables } from '../../components/utils/utils'

export default {
  state: {
    salesQueryBuilderConfig: {},
    settings: {}
  },
  mutations: {
    'SET_SALES_QUERY_BUILDER_CONFIG': function (state, settings) {
      state.salesQueryBuilderConfig = settings
    },
    'SET_SETTINGS': function (state, settings) {
      state.settings = settings
    }
  },
  actions: {
    getSettings ({ commit, getters, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          if (!getters.settings.length) {
            const decodedAccessToken = rootGetters['session/decodedAccessToken']
            const endpoint = setQueryStringVariables('/api/v1/setting', { scopes: decodedAccessToken.scopes.join(',') })
            const { settings } = (await backend.get(endpoint, rootGetters['session/accessToken'])).body
            commit('SET_SETTINGS', settings)
            resolve(getters.settings)
          } else {
            resolve(getters.settings)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async getSalesQueryBuilderConfig ({ commit, getters, rootGetters }) {
      try {
        if (_.isEmpty(getters.salesQueryBuilderConfig.length)) {
          const config = (await backend.get('/api/v1/sales-query-builder-config', rootGetters['session/accessToken'])).body
          commit('SET_SALES_QUERY_BUILDER_CONFIG', config)
          return getters.salesQueryBuilderConfig
        } else {
          return getters.salesQueryBuilderConfig
        }
      } catch (error) {
        throw error
      }
    }
  },
  getters: {
    salesQueryBuilderConfig: state => state.salesQueryBuilderConfig,
    settings (state) {
      if (Object.keys(state.settings).length) {
        let { markets, countries, ...otherSettings } = state.settings
        countries = countries.sort((c1, c2) => Object.values(c1).flat() - Object.values(c2).flat())
        markets = state.settings.markets
          .sort((m1, m2) => m1.codMarket - m2.codMarket)
          .map(market => market.codMarket)
        const timezones = {}
        const zipCodeRegex = {}
        state.settings.markets.forEach(market => {
          timezones[market.codMarket] = market.timezone
          zipCodeRegex[market.codMarket] = market.zipCodeRegex
        })
        return {
          countries,
          markets,
          timezones,
          zipCodeRegex,
          ...otherSettings
        }
      } else {
        return state.settings
      }
    }
  },
  namespaced: true
}
